// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { utils } from '@seedplanner/shared-utils';
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Box, Typography } from '../../lib/base';

interface Phase {
  readonly label: string;
  readonly duration: number;
  readonly id: string;
}

interface GrowthTimelineProps {
  readonly phases: Phase[];
}

const GrowthTimeline: React.FC<GrowthTimelineProps> = ({ phases }) => {
  // Calculate the total duration of all phases
  const totalDuration = phases.reduce((acc, curr) => acc + curr.duration, 0);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', overflow: 'hidden' }}>
      {phases.map((phase, index) => {
        // Calculate the width of each phase based on its duration as a percentage of the total duration
        const widthPercentage = (phase.duration / totalDuration) * 100;
        const days = utils.round(phase.duration / 24 / 60 / 60, 1);

        return (
          <Box
            key={phase.id}
            width={`${widthPercentage}%`}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            sx={{
              bgcolor: index % 2 === 0 ? 'primary.main' : 'secondary.dark',
              borderRadius:
                index === 0 && index === phases.length - 1
                  ? '4px'
                  : index === 0
                    ? '4px 0 0 4px'
                    : index === phases.length - 1
                      ? '0 4px 4px 0'
                      : 0,
            }}
          >
            <Typography
              variant="caption"
              noWrap
              sx={{
                color: 'white',
                width: '100%',
                textAlign: 'center',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                px: 1,
              }}
            >
              {phase.label} ({days} days)
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default GrowthTimeline;
